import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.starts-with.js";
import { getInvStatusNamesApi } from '@/api/selfAnalysis';

import { mapState, mapActions } from 'vuex';
import downloadCsv from 'download-csv';
export default {
  name: 'DeviceStatus',
  data: function data() {
    return {
      sortBy: 'INV 名稱',
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      isOnlyPV: false,
      stateSlot: 'cell(INV 狀態)',
      // 自主分析 07 的 { 狀態碼: 名稱 }，依 inv_index；沒填過就是空陣列，欄位只顯示原始碼
      statusNames: []
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('deviceStatus', ['deviceStatusChartOptions', 'tableField', 'tableData', 'dataTime'])), mapState(['dark', 'tableThColor', 'factoryData'])), {}, {
    rows: function rows() {
      return this.tableData.length;
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['asyncLastSingleDoc', 'updateDevicesStatusState'])), mapActions('deviceStatus', ['handleTableField'])), {}, {
    stateText: function stateText(row) {
      var _this$statusNames$row, _this$statusNames$row2;
      var code = row['INV 狀態'];
      if (code === null || code === undefined) return '';
      return (_this$statusNames$row = (_this$statusNames$row2 = this.statusNames[row._invIndex]) === null || _this$statusNames$row2 === void 0 ? void 0 : _this$statusNames$row2[code]) !== null && _this$statusNames$row !== void 0 ? _this$statusNames$row : code;
    },
    // 發電離群的 hover 說明
    deviationTitle: function deviationTitle(row) {
      var deviation = row['發電偏離度 (%)'];
      var basis = row._peerBasis;
      var direction = deviation > 0 ? '高' : '低';
      var magnitude = Math.abs(deviation);
      var yieldText = function yieldText(v) {
        return "".concat(v.toFixed(2), " kWh/kWp");
      };
      var capText = basis.capMin === basis.capMax ? "".concat(basis.capMin, " kWp") : "".concat(basis.capMin, "~").concat(basis.capMax, " kWp");
      var groupText = "".concat(basis.count, " \u53F0\u540C\u5BB9\u91CF\u6A5F\u7D44\uFF08").concat(capText, "\uFF09");

      // 完全沒發電，與日照強弱無關，故不提門檻
      if (row._peerMode === 'dead') {
        return ['今日完全沒有發電，瞬時功率也是 0', "\u540C\u5115\u4ECD\u5728\u767C\u96FB\uFF0C\u57FA\u6E96 ".concat(yieldText(basis.ref), "\uFF0C\u672C\u53F0 ").concat(yieldText(0)), "\u6BD4\u8F03\u57FA\u790E\uFF1A".concat(groupText)].join('\n');
      }

      // 同容量僅兩台時無第三方可投票，只能指出這一對有異常，無法歸屬
      if (row._peerMode === 'pair') {
        return ['同容量僅兩台，彼此差異過大 — 無法判斷何者異常，請至現場確認', "\u672C\u53F0 ".concat(yieldText(basis.self), "\uFF0C\u53E6\u4E00\u53F0 ").concat(yieldText(basis.ref), "\uFF08\u672C\u53F0").concat(direction, " ").concat(magnitude, "%\uFF09"), "\u6BD4\u8F03\u57FA\u790E\uFF1A".concat(groupText, "\uFF0C\u9580\u6ABB \xB1").concat(basis.limit, "%")].join('\n');
      }
      return ["\u4ECA\u65E5\u767C\u96FB\u91CF".concat(direction, "\u65BC\u540C\u5115\u4E2D\u4F4D\u6578 ").concat(magnitude, "%"), "\u540C\u5115\u4E2D\u4F4D\u6578 ".concat(yieldText(basis.ref), "\uFF0C\u672C\u53F0 ").concat(yieldText(basis.self)), "\u6BD4\u8F03\u57FA\u790E\uFF1A".concat(groupText), "\u9580\u6ABB \xB1".concat(basis.limit, "%")].join('\n');
    },
    downloadAnalysis: function downloadAnalysis() {
      var _this = this;
      // 移除底線開頭的內部欄位 (_cellVariants、_peerMode)
      var downloadData = this.tableData.map(function (obj) {
        return Object.fromEntries(Object.entries(obj).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 1),
            key = _ref2[0];
          return !key.startsWith('_');
        }).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];
          return [key, key === 'INV 狀態' ? _this.stateText(obj) : value];
        }));
      });
      downloadCsv(downloadData, {}, '變流器詳細資訊.csv');
    }
  }),
  watch: {
    isOnlyPV: function isOnlyPV(newValue, _oldValue) {
      if (newValue) {
        this.handleTableField(true);
      } else {
        this.handleTableField();
      }
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this2.factoryData.length) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return _this2.asyncLastSingleDoc(_this2.$route.query.siteName);
            case 3:
              _this2.updateDevicesStatusState();
              _this2.handleTableField();
              _context.prev = 5;
              _context.next = 8;
              return getInvStatusNamesApi(_this2.$route.query.fid);
            case 8:
              res = _context.sent;
              _this2.statusNames = res.data || [];
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              console.log('inv status names failed', _context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 12]]);
    }))();
  }
};